
import { MessageBar, MessageBarType } from '@fluentui/react';
import type { GlobalNotification as NotificationType } from '@providers/AppProvider';

const TYPE_MAP: Record<NotificationType['type'], MessageBarType> = {
    info: MessageBarType.info,
    warning: MessageBarType.warning,
    error: MessageBarType.error,
    success: MessageBarType.success,
};

interface Props {
    notifications: NotificationType[];
    onDismiss: (id: string) => void;
}

export default function GlobalNotification({ notifications, onDismiss }: Props) {
    if (notifications.length === 0) return null;
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {notifications.map(n => (
                <MessageBar
                    key={n.id}
                    messageBarType={TYPE_MAP[n.type]}
                    onDismiss={() => onDismiss(n.id)}
                    isMultiline={false}
                >
                    {n.message}
                </MessageBar>
            ))}
        </div>
    );
}
